import React from "react";

export default function CustomPagination({
  now,
  all,
  onChangePage = () => {},
}) {
  return (
    <div className="flex flex-row items-center gap-4">
        <div
        onClick={() => {
          if (now > 1) {
            onChangePage(1);
          }
        }}
        className={
          "p-2 w-10 h-10 rounded-md flex flex-col justify-center items-center  " +
          (now > 1
            ? "bg-[#F89343] cursor-pointer active:opacity-50 hover:opacity-80 "
            : "bg-[#858485] cursor-not-allowed")
        }
      >
        <img
          src="/img/arrowLeft2.png"
          className="h-[70%] w-full object-contain"
        />
      </div>
      <div
        onClick={() => {
          if (now > 1) {
            onChangePage(now - 1);
          }
        }}
        className={
          "p-2 w-10 h-10 rounded-md  " +
          (now > 1
            ? "bg-[#F89343] cursor-pointer active:opacity-50 hover:opacity-80 "
            : "bg-[#858485] cursor-not-allowed")
        }
      >
        <img
          src="/img/arrowLeft.png"
          className="h-full w-full object-contain"
        />
      </div>
      {Array.from(Array(all).keys()).map((item, i) => {
        return i >= now - 4 && i <= now + 2 ? (
          <div
            key={i}
            onClick={() => {
              if (now != i + 1) {
                onChangePage(i + 1);
              }
            }}
            className={
              "p-2 w-10 h-10 rounded-md select-none font_Kanit font-medium text-[20px] flex flex-col justify-center items-center text-white  " +
              (now == i + 1
                ? "bg-[#F89343] cursor-not-allowed "
                : "bg-[#858485] cursor-pointer  active:opacity-50 hover:opacity-80 hidden sm:flex")
            }
          >
            {item + 1}
          </div>
        ) : null;
      })}
      <div
        onClick={() => {
          if (now < all) {
            onChangePage(now + 1);
          }
        }}
        className={
          "p-2 w-10 h-10 rounded-md  " +
          (now < all
            ? "bg-[#F89343] cursor-pointer active:opacity-50 hover:opacity-80 "
            : "bg-[#858485] cursor-not-allowed")
        }
      >
        <img
          src="/img/arrowRight.png"
          className="h-full w-full object-contain"
        />
      </div>
      
      <div
        onClick={() => {
          if (now < all) {
            onChangePage(all);
          }
        }}
        className={
          "p-2 w-10 h-10 rounded-md flex flex-col justify-center items-center " +
          (now < all
            ? "bg-[#F89343] cursor-pointer active:opacity-50 hover:opacity-80 "
            : "bg-[#858485] cursor-not-allowed")
        }
      >
        <img
          src="/img/arrowRight2.png"
          className="h-[70%]  w-full object-contain"
        />
      </div>
    </div>
  );
}
